import { render, staticRenderFns } from "./NoBusinesses.vue?vue&type=template&id=76a45e14&"
import script from "./NoBusinesses.vue?vue&type=script&lang=js&"
export * from "./NoBusinesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports